import { useLazyQuery, useMutation } from '@apollo/client';
import ExamGuideContainer from '../../components/ExamGuideContainer/ExamGuideContainer';
import LibraryHeader from '../../components/LibraryHeader/LibraryHeader';
import PDFViewer from '../../components/PDFViewer/PDFViewer';
import FileUpload from '../../components/Popups/FileUpload';
import { DELETE_EBOOK_MATERIAL, UPDATE_EBOOK_MATERIAL, UPLOAD_MATERIAL, VIEW_ALL_EBOOK_MATERIAL } from '../TeacherTeachingMaterial/api/TeacherTeachingMaterialQuery';
import './TeacherExaminationGuide.scss';
import { useEffect, useState } from 'react';
import ToasterWithMessage from '../../components/toaster';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import UploadToaster from '../../components/Popups/UploadProgressBar/UploadProgressPopup';
import { useAppSelector } from '../../redux/app/hooks';
import { STUDENT_ROLE } from '../../utils/constants';
import { READ_CLASSROOMUPDATES } from '../TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import images from '../../assets/images';
import { getScreenDimensions } from '../../utils/helper';

interface guidesData {
    filename: string;
    filepath: string;
    filesize: number;
    isclassroom: boolean;
    coverimagepath: string;
    authorname: string;
    fileId: string;
    feedId? : string;
};

const TeacherExaminationGuide = () => {
    const [url, setUrl] = useState<string>();
    const [filename, setFilename] = useState<string>();
    const [pdfFileData, setPdfFileData] = useState<guidesData | undefined>();
    const [fileData, setFileData] = useState<File | null>();
    const [guideCoverUrl,setGuideCoverUrl] = useState<string>();
    const [guideAuthorName, setGuideAuthorName] = useState<string>();
    const [isUploadOpen, setIsUploadOpen] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const [openPdf, setOpenPdf] = useState(false);
    const [guidesData, setGuidesData] = useState<[guidesData]>();
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadFailed, setUploadFailed] = useState<boolean>(false);
    const [uploadFileName, setUploadFileName] = useState<string>('');
    const [materialAction,setMaterialAction] = useState<string>('');
    const [uploaded, setuploaded] = useState(false);
    const { success, error } = ToasterWithMessage();
    const { state } = useLocation();
    const selectedLibraryId = localStorage.getItem('selectedLId');
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const role = useAppSelector((state) => state.auth.role);
    const backNavigation = role ===STUDENT_ROLE ? '/student-classroom/ebooks/materials' : '/teacher-classroom/ebooks/materials';
    const navigate = useNavigate();
    const profile = useAppSelector((state) => state.auth.adminProfile);
    const { uploadCloud } = images;

    const [getAllExaminationGuide, { loading }] = useLazyQuery(VIEW_ALL_EBOOK_MATERIAL, {
        fetchPolicy: 'network-only',
        onCompleted: (data) => {
            if (data?.getMaterialsFromEbookType?.nodes) {
                setGuidesData(data?.getMaterialsFromEbookType?.nodes);
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/ebooks', { state: { title: 'E-Books' } });
                    } else {
                        navigate('/teacher-classroom/ebooks', { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

    const [readFeed] = useMutation(READ_CLASSROOMUPDATES, {
        fetchPolicy: 'network-only',
        onCompleted : (data) =>{
        },
        onError: (err) =>{
          console.log(err.message)
        }
      })
    
      useEffect(()=>{
    if(role === STUDENT_ROLE){
      if(guidesData && guidesData.length > 0){
        guidesData?.forEach((data) => {
          if (data.feedId) {
            readFeed({
              variables: {
                fId: data.feedId,
                uId: profile?.getCurrentUser?.nodes[0]?.uId
              }
            })
          }
        });
      }
    }
      },[guidesData, profile?.getCurrentUser?.nodes, readFeed, role])

    const [uploadExaminationGuide] = useMutation(UPLOAD_MATERIAL, {
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            if (data?.insertMaterialIntoEbookMaterials) {
                setFileData(null);
                if (filename) {
                    setUploadFileName(filename);
                }
                setuploaded(true);
                setUploadProgress(100);
                setFilename('');
                setUrl('');
                setGuideCoverUrl('');
                setGuideAuthorName('');
                getAllExaminationGuide({
                    variables: {
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                        type: "Examination Guide",
                        cId: selectedClassRoomId,
                        limit: null,
                        offset: null,
                        searchInput: '%',
                        orderByColumn: null,
                        orderByDirection: null,
                        isclassroom: role === STUDENT_ROLE ? true : [true, false],
                    }
                })
            }
        },
        onError: (err) => {
            if (filename) {
                setUploadFileName(filename);
            }
            setuploaded(true);
            setUploadProgress(0);
            setUploadFailed(true);
        }
    });

    const [updateExaminationGuide] = useMutation(UPDATE_EBOOK_MATERIAL, {
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            if (data?.updateEbookMaterials) {
                if(materialAction === "share"){
                    success("Shared successfully");
                }else if(materialAction === "undoShare"){
                    success("Unshared successfully");
                }
                getAllExaminationGuide({
                    variables: {
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                        type: "Examination Guide",
                        cId: selectedClassRoomId,
                        limit: null,
                        offset: null,
                        searchInput: '%',
                        orderByColumn: null,
                        orderByDirection: null,
                        isclassroom: role === STUDENT_ROLE ? true : [true, false],
                    }
                })
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/ebooks', { state: { title: 'E-Books' } });
                    } else {
                        navigate('/teacher-classroom/ebooks', { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

    const [deleteExaminationGuide] = useMutation(DELETE_EBOOK_MATERIAL, {
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            if (data?.deleteEbookMaterials) {
                success("Deleted successfully");
                getAllExaminationGuide({
                    variables: {
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                        type: "Examination Guide",
                        cId: selectedClassRoomId,
                        limit: null,
                        offset: null,
                        searchInput: '%',
                        orderByColumn: null,
                        orderByDirection: null,
                        isclassroom: role === STUDENT_ROLE ? true : [true, false],
                    }
                })
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/ebooks', { state: { title: 'E-Books' } });
                    } else {
                        navigate('/teacher-classroom/ebooks', { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

    useEffect(() => {
        getAllExaminationGuide({
            variables: {
                lId: selectedLibraryId,
                sjId: selectedSubjectId,
                type: "Examination Guide",
                cId: selectedClassRoomId,
                limit: null,
                offset: null,
                searchInput: '%',
                orderByColumn: null,
                orderByDirection: null,
                isclassroom: role === STUDENT_ROLE ? true : [true, false],
            }
        });
    }, []);

    useEffect(() => {
        if (fileData && filename && filename !== '' && url && guideAuthorName) {
            uploadExaminationGuide({
                variables: {
                    filename: filename?.replace(/\.pdf$/, ""),
                    filepath: url,
                    filesize: fileData?.size,
                    isclassroom: false,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: "Examination Guide",
                    filetype: 'pdf',
                    cId: selectedClassRoomId,
                    authorName:guideAuthorName?.trim(),
                    coverImagePath: guideCoverUrl || null
                }
            });
        }
    }, [fileData, filename, url, guideAuthorName, guideCoverUrl]);

    //To open pdf in detailed view
    const handleOpenFile = (pdfData: guidesData) => {
        setOpenPdf(true);
        setPdfFileData(pdfData);
    }

    //To close pdf detailed view
    const handleClosePdf = () => {
        setOpenPdf(false);
        setPdfFileData(undefined);
    }

    const handleOpenUpload = () => {
        setIsUploadOpen(true);
        setOpen(true);
    };

    //To done actions in materials
    const handleMaterialActions = (data: guidesData, action: string) => {
        if (action === "share") {
            setMaterialAction("share");
            updateExaminationGuide({
                variables: {
                    isClassroom: true,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: "Examination Guide",
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            });
        } else if (action === "undoShare") {
            setMaterialAction("undoShare");
            updateExaminationGuide({
                variables: {
                    isClassroom: false,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: "Examination Guide",
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            });
        } else if (action === "delete") {
            setMaterialAction('');
            deleteExaminationGuide({
                variables: {
                    cId: selectedClassRoomId,
                    fId: data?.fileId,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: "Examination Guide"
                }
            })
        }
    };

    return (
        <div className="teacherExaminationGuide">
            <LibraryHeader
                image={state?.imageSrc}
                backgroundColor={state?.backGroundColor}
                subject={state?.title}
                subCategory={'Examination Guideline'}
                setIsUploadOpen={setIsUploadOpen}
                openPdf={openPdf}
                onClose={handleClosePdf}
                setOpen={setOpen}
                backNavigation={{ path: backNavigation, state: state }}
            />
            {
                openPdf ?
                    <PDFViewer file={pdfFileData?.filepath ? baseUrl + pdfFileData.filepath : ''} pdfFileData={pdfFileData} onClose={handleClosePdf} type={"Examination Guide"} />
                    :
                    <>
                        {
                            loading ? <Loader bottom='165px' />
                                :
                                <div className='teacherExaminationGuideBody'>
                                    <ExamGuideContainer
                                        guidesData={guidesData}
                                        handleOpenFile={handleOpenFile}
                                        handleMaterialActions={handleMaterialActions}
                                    />
                                </div>
                        }
                    </>
            }
            {/* {isUploadOpen && <FileUpload type='pdf' name="Examination Guide" setGuideAuthorName = {setGuideAuthorName} setCoverImageUrl ={setGuideCoverUrl} setUrl={setUrl} open={open} setOpen={setOpen} folderName="materials" setFilename={setFilename} setFileData={setFileData} />} */}
            {isUploadOpen && <FileUpload type='pdf' name="Examination Guide" setGuideAuthorName = {setGuideAuthorName} setCoverImageUrl ={setGuideCoverUrl} setUrl={setUrl} open={open} setOpen={setOpen} setIsUploadOpen={setIsUploadOpen} folderName="materials" setFilename={setFilename} setFileData={setFileData} setUploadFailed={setUploadFailed} setUploadProgress={setUploadProgress} setuploaded={setuploaded} setUploadFileName={setUploadFileName}/>}
            {uploaded && <UploadToaster uploaded={uploaded} setuploaded={setuploaded} uploadProgress={uploadProgress} setUploadProgress={setUploadProgress} fileName={uploadFileName} setUploadFileName={setUploadFileName} uploadFailed={uploadFailed} setUploadFailed={setUploadFailed} />}

            {(getScreenDimensions()?.isMobileScreen && role !== STUDENT_ROLE) && !openPdf &&
                            <div className='libraryHeaderUploadContainer'> 
                                <div className='libraryHeaderUpload' onClick={handleOpenUpload}>
                                    <img src={uploadCloud} alt="upload" className='uploadImage' />
                                </div>
                            </div>}
        </div>
    )
}

export default TeacherExaminationGuide;
